import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appPrefix'
})
export class AppPrefixPipe implements PipeTransform {
  transform(title: string, prefix: string = 'for'): string {
    if (!title) {
      return '';
    } else {
      if (title.length > 30) {
        title = title.substring(0, 30) + '...';
      }

      return `${prefix} ${title}`;
    }
  }
}
